import { mutations } from "./mutations";
import { getters } from "./getters";
import { actions } from "./actions";
import { chartState } from "./state";

const defaultState: chartState = {
  echartOptions: {
    data: {
      lineChartOption: {
        title: {
          text: "lineChart",
        },
        tooltip: {},
        xAxis: {
          data: [],
        },
        yAxis: {},
        series: [
          {
            name: "",
            type: "",
            data: [],
          },
        ],
      },
      polarChartOption: {
        title: {
          text: "polarChart",
        },
        legend: {
          data: [],
        },
        polar: {
          center: [],
        },
        tooltip: {
          trigger: "",
          axisPointer: {
            type: "",
          },
        },
        angleAxis: {
          type: "",
          startAngle: 0,
        },
        radiusAxis: {
          min: 0,
        },
        series: [
          {
            coordinateSystem: "",
            name: "",
            type: "",
            showSymbol: false,
            data: [],
          },
        ],
        animationDuration: 2000,
      },
      pieChartOption: {
        title: {
          text: "pieChart",
          subtext: "",
          left: "",
        },
        tooltip: {
          trigger: "",
        },
        legend: {
          orient: "",
          left: "",
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "",
            data: [
              { value: 1048, name: "搜索引擎" },
              { value: 735, name: "直接访问" },
              { value: 580, name: "邮件营销" },
              { value: 484, name: "联盟广告" },
              { value: 300, name: "视频广告" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
    },
  },
};

export const WorkbenchModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
